package games.mythical.saga.watcher.sagawatcher.model

import kotlinx.serialization.Serializable

@Serializable
data class Application(
    val name: String,
    val githubUrl: String,
    val environments: MutableMap<String, Environment>,
)